import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import startCase from 'lodash/startCase';
import { UserConsumer } from '../context/userContext';

const debuggerGlobalContainerStyles = {
  position: 'fixed',
  bottom: '20px',
  right: '20px',
  background: '#ccc',
  maxWidth: '800px',
  zIndex: '9999'
};

// const buttonStyles = {
//   boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 8px',
//   height: '40px',
//   width: '150px',
//   margin: '20px',
//   display: 'inline-block'
// };

const tableDataContainerStyles = {
  padding: '8px',
  margin: '8px',
  border: '1px solid',
  overflowY: 'scroll'
};

const VisualDebugger = ({ trackedDataObject }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [currentItems, setCurrentItems] = useState([]); // eslint-disable-line
  // const experienceEnabled = Cookies.get('_pc_v1uc') === '282020';
  // const [format, setFormat] = useState('raw'); // Display format i.e. `raw` vs. `table` vs. ???

  const isUniquePageView = () => {
    const currentInfo = JSON.parse(localStorage.getItem('_history') || '[]');

    return (
      currentInfo.filter(
        view => view.location === get(window, 'location.pathname')
      ).length <= 0
    );
  };

  const handleInitialPageLoad = () => {
    const currentInfo = localStorage.getItem('_history') || '[]';
    const mainObj = JSON.parse(currentInfo);
    const currentDate = Date.now();
    const isUnique = isUniquePageView();

    const newPageInfo = {
      label: new Date(currentDate).toLocaleString('en-US', { hour12: true }),
      name: document.title || 'Default Page Visit',
      location: get(window, 'location.pathname', 'Unknown Location'),
      date: currentDate,
      isUnique
    };

    mainObj.push(newPageInfo);
    localStorage.setItem('_history', JSON.stringify(mainObj));

    setCurrentItems(currentDate);
  };

  const trackNewPageView = () => {
    const currentInfo = localStorage.getItem('_history') || '[]';
    const mainObj = JSON.parse(currentInfo);
    const currentDate = Date.now();
    const isUnique = isUniquePageView();

    const newPageInfo = {
      label: new Date(currentDate).toLocaleString('en-US', { hour12: true }),
      name: document.title || 'Default Page Visit',
      location: get(window, 'location.pathname', 'Unknown Location'),
      date: currentDate,
      isUnique
    };
    mainObj.push(newPageInfo);
    localStorage.setItem('_history', JSON.stringify(mainObj));

    setCurrentItems(currentDate);
  };

  const listenForElementMutation = element => {
    new MutationObserver(mutations => { // eslint-disable-line
      trackNewPageView();
    }).observe(document.querySelector(element), {
      subtree: true,
      characterData: true,
      childList: true
    });
  };

  useEffect(() => {
    // Append vists to `pageVisits` array on PAGE LOAD
    handleInitialPageLoad();

    // Listen for title tag change, for SPA tracking
    listenForElementMutation('title');
  }, []); // eslint-disable-line

  const tableizeObject = (object, name = 'Data') => (
    <details open>
      <summary className="tableDataName">{startCase(name)}</summary>
      <table aria-label="simple table">
        <tr>
          {Object.keys(object).map((item, i) => (
            <th key={`debug-table-header-${i}`}>{item}</th>
          ))}
        </tr>
        <tr>
          {Object.values(object).map((item, i) => {
            let value = item;
            if (typeof item === 'object' || typeof item === 'boolean') {
              value = JSON.stringify(item);
            }
            return <td key={`debug-table-data-${i}`}>{value}</td>;
          })}
        </tr>
      </table>
    </details>
  );

  const localHistory = JSON.parse(localStorage.getItem('_history') || '[]');

  return (
    <div
      id="InlineDebugger"
      style={debuggerGlobalContainerStyles}
      className={collapsed && 'collapsed'}
    >
      <span
        className="displayToggle"
        onClick={e => {
          e.preventDefault();
          setCollapsed(!collapsed);
        }}
      >
        {collapsed ? '▲' : 'X'}
      </span>
      <div className="debugData">
        {Object.keys(trackedDataObject).map((data, i) => {
          const dataValues = Object.values(trackedDataObject)[i];
          if (isEmpty(dataValues)) return null; // If empty object, return nothing
          return (
            <div
              key={`data-object-${i}`}
              className="tableDataContainer"
              style={tableDataContainerStyles}
            >
              {tableizeObject(dataValues, data)}
            </div>
          );
        })}
      </div>
      <UserConsumer>
        {({ showScreen }) => ( // eslint-disable-line
          <div className="debugButtons">
            {/* <button
              style={buttonStyles}
              onClick={() => {
                showScreen('login');
              }}
            >
              Trigger Login
            </button>
            <button
              style={buttonStyles}
              onClick={() => {
                showScreen('register');
              }}
            >
              Trigger Register
            </button> */}
            {/* <button
              style={buttonStyles}
              onClick={() => {
                if (experienceEnabled) {
                  Cookies.remove('_pc_v1uc');
                } else {
                  Cookies.set('_pc_v1uc', '282020', { expires: 7 });
                }

                // RELOAD THE PAGE
                window.location.href = `${window.location.pathname}?xpdebug`;
              }}
            >
              {experienceEnabled ? 'Disable' : 'Enable'} Experience
            </button> */}
          </div>
        )}
      </UserConsumer>
      <div className="debugHistory">
        {localHistory.reverse().map(item => (
          // <div>{item.name}</div>
          <details>
            <summary className="tableDataName">{`${
              item.isUnique ? '🚨' : '✅'
            } ${item.label} - ${item.location}`}</summary>
            <div>
              <div>{item.name}</div>
            </div>
          </details>
        ))}
      </div>
    </div>
  );
};

VisualDebugger.defaultProps = {
  trackedDataObject: {}
};

VisualDebugger.propTypes = {
  trackedDataObject: PropTypes.arrayOf(PropTypes.shape({}))
};

export default VisualDebugger;
